var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9999 6.5L12.7999 1.7C13.0999 1.4 13.0999 0.9 12.7999 0.6C12.4999 0.3 11.9999 0.3 11.6999 0.6L6.8999 5.4L2.1999 0.6C1.8999 0.3 1.3999 0.3 1.0999 0.6C0.999899 0.8 0.899902 1 0.899902 1.1C0.899902 1.3 0.999899 1.5 1.0999 1.7L5.8999 6.5L1.0999 11.2C0.999899 11.3 0.899902 11.6 0.899902 11.8C0.899902 11.9 0.999899 12.2 1.0999 12.3C1.1999 12.4 1.4999 12.5 1.5999 12.5C1.7999 12.5 1.9999 12.4 2.1999 12.3L6.8999 7.5L11.6999 12.3C11.7999 12.4 12.0999 12.5 12.2999 12.5C12.3999 12.5 12.6999 12.4 12.7999 12.3C13.0999 12 13.0999 11.5 12.7999 11.2L7.9999 6.5Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.fc44ed5a0f854f48eb1cf65703dd1bb6.svg";
export { ForwardRef as ReactComponent };